import { handleApiError, handleApiResponse } from "../utils/utils";
import { ApiClient } from "./apiConfig";

export const assetUpload = async ({ file }) => {
  try {
    const resp = await ApiClient.post("/assets/asset-upload", { file: file });
    const result = handleApiResponse(resp);
    return result;
  } catch (err) {
    console.log(err);
    handleApiError(err);
  }
};

export const assetRemove = async ({ file }) => {
  try {
    const resp = await ApiClient.post("/assets/asset-remove", { file: file });
    const result = handleApiResponse(resp);
    return result;
  } catch (err) {
    console.log(err);
    handleApiError(err);
  }
};
